// Hevi Haul Inc. - Website Content Data

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_5d3d7d2f-8e68-49b4-af90-6d319bb55dfa/artifacts/yhdwi5me_WhatsApp%20Image%202026-02-19%20at%2008.09.07.jpeg";

export const COMPANY = {
  name: "Hevi Haul Inc.",
  tagline: "You Call, We Haul.",
  email: "info@hevihaulinc.ca",
  emailSecondary: "hevihaulinc@gmail.com",
  phone: "+1 647 773 6944",
  address: "",
  dispatchHours: "24/7",
  officeHours: "Mon–Fri, 7AM–6PM",
  since: 2015,
};

export const HERO = {
  label: "Niagara Region's Most Trusted Carrier — Since 2015",
  headline: "STOP LOSING MONEY ON LATE FREIGHT & BROKEN PROMISES",
  subheadline: "Ontario's businesses trust Hevi Haul to move their most critical loads — on time, every time. Flatbed, heavy equipment, walking floor, and cross-border hauling with zero excuses.",
  highlight: "10+ years. 10+ trucks. One phone call.",
  riskReversal: "No hidden fees. No surprise charges. Transparent pricing — guaranteed.",
  ctaPrimary: "Get Your Free Quote",
  ctaSecondary: "Call Now",
  bgImage: "https://images.pexels.com/photos/27508769/pexels-photo-27508769.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const TRUST_BADGES = [
  { label: "CVOR Certified", icon: "ShieldCheck" },
  { label: "Fully Insured & Bonded", icon: "Shield" },
  { label: "Cross-Border Approved", icon: "Globe" },
  { label: "10+ Years Incident-Free", icon: "Award" },
  { label: "GPS-Tracked Fleet", icon: "MapPin" },
];

export const PROBLEMS = {
  label: "THE REAL COST OF BAD TRUCKING",
  headline: "YOUR CURRENT CARRIER IS COSTING YOU MORE THAN YOU THINK",
  subheadline: "Every late delivery, every missed call, every damaged load is money walking out your door. Sound familiar?",
  cards: [
    {
      title: "Late & Unreliable Deliveries",
      icon: "Clock",
      description: "Your freight shows up late — or doesn't show up at all. Your production line stops. Your customers lose trust. You lose contracts worth thousands.",
    },
    {
      title: "Hidden Fees & Surprise Charges",
      icon: "DollarSign",
      description: "The quote said one thing. The invoice says another. Fuel surcharges, wait time fees, accessorial charges you never agreed to. Death by a thousand cuts.",
    },
    {
      title: "Zero Communication",
      icon: "PhoneOff",
      description: "You call dispatch. No answer. You email. Nothing. Your load is somewhere between Point A and Point B and nobody can tell you where. You're flying blind.",
    },
  ],
};

export const SERVICES = {
  label: "WHAT WE HAUL",
  headline: "COMPREHENSIVE TRUCKING SOLUTIONS — ONE CALL DOES IT ALL",
  subheadline: "From flatbed steel shipments to cross-border heavy equipment moves, Hevi Haul has the fleet, the crew, and the experience to handle your toughest loads.",
  items: [
    {
      title: "Flatbed Trucking",
      icon: "Truck",
      description: "Steel coils, lumber, machinery, building materials — if it's oversized or awkward, our flatbed fleet handles it. Expert load securement across Ontario, Quebec, and the Northeastern US.",
      image: "https://images.unsplash.com/photo-1742069029207-0aacf8fa4401?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxmbGF0YmVkJTIwdHJ1Y2t8ZW58MHx8fHwxNzcxNTMwMjM3fDA&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Heavy Equipment Hauling",
      icon: "Container",
      description: "Excavators, bulldozers, cranes, industrial machinery — we specialize in the loads other carriers won't touch. Step deck and float trailers. Permit management included.",
      image: "https://images.pexels.com/photos/35846752/pexels-photo-35846752.jpeg",
    },
    {
      title: "Walking Floor Services",
      icon: "Layers",
      description: "Bulk commodities, wood chips, recyclables, aggregate — our walking floor trailers provide efficient, hands-free unloading. Ideal for high-volume, time-sensitive operations.",
      image: "https://images.unsplash.com/photo-1766608422198-5be9ac0aac9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHx0cnVja2luZyUyMGxvZ2lzdGljc3xlbnwwfHx8fDE3NzE1MzAyNDF8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Shuttle Services",
      icon: "ArrowLeftRight",
      description: "Dedicated point-to-point shuttle runs between your facilities, warehouses, and job sites. Consistent schedules. Same driver familiarity.",
      image: "https://images.pexels.com/photos/29786116/pexels-photo-29786116.jpeg",
    },
    {
      title: "Cross-Border Freight",
      icon: "Globe",
      description: "Strategically located in Niagara Falls — minutes from the US border. Daily runs to Western New York and beyond. All customs documentation handled for you.",
      image: "https://images.unsplash.com/photo-1720811559337-c59b75acc4de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHx0cnVja2luZyUyMGxvZ2lzdGljc3xlbnwwfHx8fDE3NzE1MzAyNDF8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "LTL & Partial Load Shipping",
      icon: "Package",
      description: "Don't have a full truck? Consolidate your partial loads with our LTL service and save up to 40% versus booking a full trailer.",
      image: "https://images.pexels.com/photos/28264507/pexels-photo-28264507.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
      title: "Dry Bulk & Aggregate Hauling",
      icon: "Mountain",
      description: "Sand, gravel, asphalt, concrete, topsoil — our dump trailer and bulk fleet keeps construction sites and industrial operations moving.",
      image: "https://images.unsplash.com/photo-1763478488192-be34b513f424",
    },
    {
      title: "Warehousing & Cross-Docking",
      icon: "Warehouse",
      description: "Short-term storage, cross-dock transloading, and container destuffing. Switch from international containers to domestic trailers seamlessly.",
      image: "https://images.pexels.com/photos/11666903/pexels-photo-11666903.jpeg",
    },
    {
      title: "Hot Shot / Expedited Delivery",
      icon: "Zap",
      description: "Emergency freight? Equipment breakdown on a job site? Our hot shot service gets critical parts and materials there in hours — not days.",
      image: "https://images.unsplash.com/photo-1770149683239-e22145da01ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxmbGF0YmVkJTIwdHJ1Y2t8ZW58MHx8fHwxNzcxNTMwMjM3fDA&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Construction & Excavation Support",
      icon: "HardHat",
      description: "Dedicated fleet support for construction projects — material delivery, equipment mobilization, site-to-site transfers, and debris removal.",
      image: "https://images.pexels.com/photos/35846752/pexels-photo-35846752.jpeg",
    },
  ],
};

export const VALUE_ITEMS = {
  label: "THE HEVI HAUL DIFFERENCE",
  headline: "WHY 100+ BUSINESSES ACROSS ONTARIO REFUSE TO USE ANYONE ELSE",
  items: [
    {
      title: "Dedicated Account Manager",
      icon: "UserCheck",
      description: "One person. One phone number. They know your loads, your schedules, and your preferences.",
      value: "Peace of mind",
    },
    {
      title: "Real-Time GPS Fleet Tracking",
      icon: "Radar",
      description: "Know exactly where your load is — 24/7. Live tracking links sent to your phone.",
      value: "Total visibility",
    },
    {
      title: "On-Time Delivery Guarantee",
      icon: "Timer",
      description: "We don't just promise on-time — we guarantee it. Full transparency if anything changes.",
      value: "Trust",
    },
    {
      title: "Transparent, All-Inclusive Pricing",
      icon: "Receipt",
      description: "The price we quote is the price you pay. No fuel surcharges buried in fine print.",
      value: "Budget certainty",
    },
    {
      title: "Cross-Border Expertise",
      icon: "Globe",
      description: "FAST-approved drivers. C-TPAT compliant. We handle all customs paperwork seamlessly.",
      value: "Hassle-free cross-border",
    },
    {
      title: "Modern, Maintained Fleet",
      icon: "Wrench",
      description: "10+ well-maintained trucks with GPS, ELD compliance, and regular safety inspections.",
      value: "Reliability",
    },
  ],
};

export const GUARANTEE = {
  headline: 'OUR "ZERO-HEADACHE" GUARANTEE',
  description: "We'll match or beat any comparable written quote for the same lane and service. And if we don't deliver the experience we promised, we'll make it right — no arguments, no runaround. Your freight is our reputation, and we protect both.",
};

export const SOCIAL_PROOF = {
  label: "THE NUMBERS DON'T LIE",
  headline: "A DECADE OF DELIVERING RESULTS — NOT EXCUSES",
  stats: [
    { value: "10+", label: "Years in Business" },
    { value: "10+", label: "Trucks on the Road" },
    { value: "1,000+", label: "Loads Delivered Annually" },
    { value: "98%", label: "On-Time Delivery Rate" },
  ],
  testimonials: [
    {
      text: "We switched to Hevi Haul after our previous carrier missed three deliveries in a row. That was two years ago. They haven't missed one since. Our production schedule has never been smoother.",
      author: "Operations Manager",
      company: "Steel Fabrication Company, Hamilton ON",
      rating: 5,
    },
    {
      text: "The cross-border service is what won us over. Our loads clear Niagara faster than with any other carrier we've tried. And Gourav's team actually picks up the phone when we call.",
      author: "Logistics Director",
      company: "Building Materials Supplier, Toronto ON",
      rating: 5,
    },
    {
      text: "We needed a walking floor carrier who could handle high volume on tight timelines. Hevi Haul showed up, delivered, and earned our business permanently. Reliable doesn't even begin to cover it.",
      author: "Plant Manager",
      company: "Recycling Facility, St. Catharines ON",
      rating: 5,
    },
  ],
};

export const COVERAGE = {
  label: "WHERE WE OPERATE",
  headline: "NIAGARA-BASED. ONTARIO-WIDE. CROSS-BORDER READY.",
  subtitle: "CANADA – US CROSS-BORDER SPECIALISTS",
  description: "Strategically located minutes from the US border for faster clearance and delivery times",
  regions: [
    "Niagara Region",
    "Greater Toronto Area (GTA)",
    "Hamilton & Burlington",
    "Southwestern Ontario",
    "Eastern Ontario & Quebec",
    "Western New York (US)",
    "Northeastern United States",
    "Cross-Border Corridors",
  ],
};

export const CTA_SECTION = {
  headline: "YOUR FREIGHT ISN'T GOING TO MOVE ITSELF",
  subheadline: "Get a free, no-obligation quote in under 2 minutes. Tell us what you're shipping, where it's going, and when it needs to be there. We'll respond within 1 hour during business hours.",
  benefits: [
    "Free custom quote tailored to your exact load",
    "Dedicated account manager assigned from day one",
    "Real-time tracking on every single shipment",
    "Price-match guarantee against any comparable written quote",
    "Zero contracts — stay because we earn it, not because you're locked in",
  ],
  urgency: "3 trucks available for dispatch this week — first come, first served",
};

export const SERVICE_OPTIONS = [
  "Flatbed Trucking",
  "Heavy Equipment Hauling",
  "Walking Floor Services",
  "Shuttle Services",
  "Cross-Border Freight",
  "LTL & Partial Load",
  "Bulk Hauling",
  "Hot Shot / Expedited",
  "Construction Support",
  "Other",
];

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why-us" },
  { label: "Results", href: "#results" },
  { label: "Coverage", href: "#coverage" },
  { label: "Contact", href: "#contact" },
];
